export const codeGenerator = (prefix = '') => {
  const randonNumber = Math.floor(Math.random() * 8999999999 + 1000000000);
  return prefix !== '' ? `${prefix}-${randonNumber}` : randonNumber;
};
